module.exports = __webpack_public_path__ + "img/loadingGif.99030af4.gif";